<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">                  
        <tabulator
            :columns="columns"
            ajax-path="connectwise/companies"
            @rowSelected="showDetails"
        />
        <app-modal
            :show.sync="showDetailsModal"
            width="lg:w-1/2"
        >
            <template slot="header">Company Information</template>
            <template slot="body">
                <vue-tabs>                    
                    <v-tab title="Basic">
                        <div class="mt-5" style="display: grid;grid-gap: 1rem;grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));">
                            <div>
                                <div class="mb-2 font-bold">Name</div>
                                <div>{{ company.name }}</div>
                            </div>
                            <div>
                                <div class="mb-2 font-bold">Site</div>
                                <div>{{ company.siteName }}</div>
                            </div>
                            <div>
                                <div class="mb-2 font-bold">Address</div>
                                <div>{{ company.addressLine1 }} {{ company.city }}, {{ company.state }} {{ company.zip }} {{ company.country ? company.country.name : '' }}</div>
                            </div>
                            <div>
                                <div class="mb-2 font-bold">Phone</div>
                                <div>{{ company.phoneNumber || '--' }}</div>
                            </div>
                            <div>
                                <div class="mb-2 font-bold">Fax</div>
                                <div>{{ company.faxNumber || '--' }}</div>
                            </div>
                            <div>
                                <div class="mb-2 font-bold">Website</div>
                                <div>
                                    <a 
                                        v-if="company.website"
                                        :href="company.website"
                                        target="_blank" 
                                    >{{ company.website }}</a>
                                    <span v-else>--</span>
                                </div>
                            </div>
                            <div>
                                <div class="mb-2 font-bold">Market</div>
                                <div>{{ company.market ? company.market.name : '--' }}</div>
                            </div>
                        </div>
                    </v-tab>
                    <v-tab title="Contacts">
                        <div 
                            class="mt-5"
                            style="display: grid;grid-gap: 1rem;grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));"
                        >
                            <div 
                                v-for="contact in company.contacts"
                                class="p-4 border border-gray-400 rounded mb-4"
                            >
                                <div><b>{{ contact.firstName }} {{ contact.lastName }}</b></div>
                                <div class="text-sm text-gray-600">Phone: {{ contact.defaultPhoneNbr || '--' }}</div>
                                <div 
                                    v-for="com in contact.communicationItems"
                                    class="text-sm text-gray-600"
                                >
                                    {{ com.communicationType }}: {{ com.value }}
                                </div>                                
                            </div>
                            <div v-if="company.contacts.length === 0">No available contacts.</div>
                        </div>
                    </v-tab>
                </vue-tabs>                                
            </template>
        </app-modal>
    </div>
</template>
<script>
    import {VueTabs, VTab} from 'vue-nav-tabs/dist/vue-tabs.js';
    import '@/css/vue-tabs.css'

    export default {
        components: {
            VueTabs,
            VTab,
        },
        data() {
            return {
                showDetailsModal: false,
                company: {
                    market: {},
                    country: {},
                    contacts: [],
                },
                columns: [
                    {
                        title: 'Name', 
                        field: 'name', 
                        sorter: 'string',
                        minWidth: 300,
                    },                    
                    {
                        title: 'Account', 
                        field: 'accountNumber', 
                        sorter: 'string',
                        minWidth: 200,
                        formatter({_cell}) {
                            return _cell.value || '--';
                        }
                    },
                    {
                        title: 'Status', 
                        field: 'status.name', 
                        sorter: 'string',
                        minWidth: 150,  
                    },
                    {
                        title: 'Primary Contact', 
                        field: 'defaultContact.name',
                        minWidth: 150,
                        formatter({_cell}) {
                            return _cell.value || '--';
                        }
                    },
                    {
                        title: 'Phone', 
                        field: 'phoneNumber',
                        minWidth: 150,
                        formatter({_cell}) {
                            return _cell.value || '--';
                        }
                    },
                    {
                        title: 'Fax', 
                        field: 'faxNumber',
                        minWidth: 150,
                        formatter({_cell}) {
                            return _cell.value || '--';
                        }
                    },
                ],
            }
        },
        methods: {
            showDetails(row) {
                this.company = row.data;
                this.showDetailsModal = true;
            },
        }
    }
</script>